import { render, staticRenderFns } from "./SimTab.vue?vue&type=template&id=7ee21050"
import script from "./SimTab.vue?vue&type=script&lang=js"
export * from "./SimTab.vue?vue&type=script&lang=js"
import style0 from "./SimTab.vue?vue&type=style&index=0&id=7ee21050&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports